import qs from "qs";
import { IAddRemoveFavoritesRequestPayload } from "../meta/interfaces/user";
import { ImageSize } from "../meta/types/casinoGamePlayModal";

type LaunchGameParams = {
  platform: string;
  gameId: string;
  sessionKey?: string;
  isMobile?: boolean;
  playForReal?: boolean;

  lang?: string;
  brandId: string;
};

export const gameLaunchURL = ({
  sessionId,
  platform,
  gameId,
  isMobile,
  funMode,
  lang
}: {
  sessionId: string | null;
  platform: string;
  gameId: string;
  isMobile?: boolean;
  funMode?: string | null;
  lang?: string;
}): string => {
  const query: LaunchGameParams = {
    platform,
    gameId,
    brandId: process.env.NEXT_PUBLIC_OMEGA_BRAND_ID as string,
    playForReal: funMode !== "true",
  };
  if (sessionId) query.sessionKey = sessionId;
  if (isMobile) query.isMobile = isMobile;
  if (lang) query.lang = lang;

  const queryString = qs.stringify(query);

  return `${process.env.NEXT_PUBLIC_OMEGA_API_URL}/game/GameContainer.action?${queryString}`;
};

export const isFavoriteGame = ({
  games,
  gameId,
  productCode,
}: {
  games: IAddRemoveFavoritesRequestPayload[];
  gameId: string;
  productCode: string;
}): boolean =>
  games?.some(
    (game) => game?.gameId === gameId && game?.platformCode === productCode
  );

export const wrapSize = (url: string, size: ImageSize) => {
  const urlObj = new URL(url);
  urlObj.searchParams.set("size", size);
  return urlObj.toString();
};
